export function validateCompetencies(testsWithCompetencies: { [key: string]: boolean | 0 | 1 | 2 | 3 | 4 }[]): boolean {
  return (
    testsWithCompetencies.length > 0 &&
    testsWithCompetencies.every((testWithCompetencies) => {
      return Object.values(testWithCompetencies).some((competency) => competency !== false);
    })
  );
}
